import React from "react";
import MealRow from "./MealRow";
import { FaPlus, FaCopy } from "react-icons/fa";

const DietPlanDay = ({ dayTitle, meals, onMealChange, onAddMeal, onRemoveMeal, onCopyPrevious, onActivityChange, onNotesChange }) => {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm">
      <div className="flex justify-between items-center mb-4 pb-2 border-b border-gray-50">
        <h4 className="text-sm font-bold text-brand-primaryColor">
          {dayTitle}
        </h4>
        <div className="flex items-center gap-2">
          {onCopyPrevious && (
            <button
              type="button"
              onClick={onCopyPrevious}
              className="flex items-center text-white gap-1 text-xs  text-blue-600 px-2 py-1 rounded-md hover:bg-blue-100 transition-colors"
            >
              <FaCopy className="w-3 h-3" />
              Same as previous day
            </button>
          )}
          <button
            type="button"
            onClick={onAddMeal}
            className="flex items-center gap-1 text-xs bg-emerald-50 text-emerald-600 px-2 py-1 rounded-md  text-white hover:bg-emerald-100 transition-colors"
          >
            <FaPlus className="w-2 h-2" />
            Add Meal
          </button>
        </div>
      </div>

      <div className="space-y-4">
        {meals.length === 0 ? (
          <p className="text-center text-gray-400 text-xs py-2">No meals added for this day</p>
        ) : (
          meals.map((meal, index) => (
            <MealRow
              key={index}
              meal={meal}
              onChange={(field, value) => onMealChange(index, field, value)}
              onRemove={() => onRemoveMeal(index)}
            />
          ))
        )}
      </div>

      <div className="mt-4 pt-3 border-t border-gray-50">
        <div className="grid grid-cols-12 gap-3 items-center">
          <div className="col-span-1 text-[10px] font-bold text-gray-400 uppercase text-right">Activity</div>
          <div className="col-span-5">
            <input
              value={meals[0]?.activity || ""}
              onChange={(e) => onActivityChange(e.target.value)}
              placeholder="Physical activity..."
              className="w-full border rounded-lg px-3 py-2 text-xs outline-none focus:border-brand-primaryColor"
            />
          </div>
          <div className="col-span-1 text-[10px] font-bold text-gray-400 uppercase text-right">Notes</div>
          <div className="col-span-5">
            <input
              value={meals[0]?.notes || ""}
              onChange={(e) => onNotesChange(e.target.value)}
              placeholder="Special instructions..."
              className="w-full border rounded-lg px-3 py-2 text-xs outline-none focus:border-brand-primaryColor"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DietPlanDay;
